import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';
import type { Props } from './types';
import { MobileLayout } from './components/MobileLayout';
import { DesktopLayout } from './components/DesktopLayout';

export const NarrativeFormContent = ({ ...props }: Props) => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  return (
    <div className="grid grid-cols-1 gap-x2 lg:grid-cols-[2fr_1fr]">
      {isMobileScreen ? (
        <MobileLayout {...props} />
      ) : (
        <DesktopLayout {...props} />
      )}
    </div>
  );
};
